// extracted by mini-css-extract-plugin
module.exports = {"contentBuy":"styles_contentBuy__2BkMN"};